import {Product} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product.types';
import {useTranslation} from '@aboutyou/i18n';
import {
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  GenericIconName,
  Icon,
  UnstyledLink,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

interface MoreDetailsProps {
  product: Product;
  replaceHistory?: boolean;
}

export const MoreDetails = ({product, replaceHistory}: MoreDetailsProps) => {
  const {t} = useTranslation();
  return (
    <MoreDetailsCTAContainer>
      <MoreDetailsCTA
        data-testid={'moreDetailsCta'}
        to={product.path}
        replace={replaceHistory}
        forcePushBehaviour={replaceHistory}
      >
        {t('More details')}
      </MoreDetailsCTA>
      <Icon asset={GenericIconName.ArrowLongRight} size="S" />
    </MoreDetailsCTAContainer>
  );
};

const MoreDetailsCTA = styled(UnstyledLink)`
  color: ${COLORS.Black};
  display: inline-block;
  font-size: ${FONT_SIZES.px12};
  font-weight: ${FONT_WEIGHTS.bold};
`;

const MoreDetailsCTAContainer = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
